import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  theme: {
    background_color: string;
    text_color: string;
    font_family: string;
  };
}

const LoadingState: React.FC<LoadingStateProps> = ({ theme }) => {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        background: `linear-gradient(to bottom right, ${theme.background_color}, ${theme.background_color}dd)`,
        color: theme.text_color,
        fontFamily: theme.font_family
      }}
    >
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin mx-auto mb-4" />
        <p className="text-lg">Carregando...</p>
      </div>
    </div>
  );
};

export default LoadingState;
